import PropTypes from 'prop-types';

var propTypes = {
    editorState: PropTypes.object.isRequired,
    className: PropTypes.string,
    placeholder: PropTypes.string.isRequired,
    label: PropTypes.string,
    onStateChange: PropTypes.func.isRequired,
};
var defaultProps = {
    placeholder: 'Description',
    label: '',
};

export { defaultProps, propTypes };
